import { Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { IConetionConfiguration } from 'app/datavisualization/core/interfaces/IConetionConfiguration';
import { IReportConfiguration } from 'app/datavisualization/core/interfaces/IReportConfiguration';
import { TableauService } from 'app/datavisualization/core/services/tableau.service';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'dv-tableau-detail',
  templateUrl: './dv-tableau-detail.component.html',
  styleUrls: ['./dv-tableau-detail.component.scss']
})
export class TableauDetailComponent implements OnInit {
  showEncryptFlagClientSecret: boolean = false;
  showEncryptFlagSecretValue: boolean = false;
  onSave: boolean = false;
  userModeSelected = '';
  errorMail: string;

  @Input() tableauConfiguration: any;
  @Input() reportConfiguration: any;
  @Input() isConexion: boolean = true;

  @Output() updateTable = new EventEmitter();

  constructor(private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _cryptoDataService: CryptoDataService,
    private tableauServices: TableauService,
    private _i18nService: I18nService) { }

  ngOnChanges() {
    if (this.tableauConfiguration?.Config?.Environment?.Params) {
      this.userModeSelected = this.tableauConfiguration.Config.Environment.Params.UserMode;
    }
  }

  ngOnInit() {
    this.cleanDescription();
  }

  encryptFieldsPassword(value) {
    if (value === 0) {
      if (this.tableauConfiguration.Config.Environment.Params.ClientSecret && (this.tableauConfiguration.Config.Environment.Params.ClientSecret.length > 0)) {
        this._cryptoDataService.encryptString(this.tableauConfiguration.Config.Environment.Params.ClientSecret).subscribe(result => {
          this.tableauConfiguration.Config.Environment.Params.ClientSecret = result.encryptedPassword;
        });
      }
    } else {
      if (this.tableauConfiguration.Config.Environment.Params.SecretValue && (this.tableauConfiguration.Config.Environment.Params.SecretValue.length > 0)) {
        this._cryptoDataService.encryptString(this.tableauConfiguration.Config.Environment.Params.SecretValue).subscribe(result => {
          this.tableauConfiguration.Config.Environment.Params.SecretValue = result.encryptedPassword;
        });
      }
    }
  }

  updateData() {
    this.onSave = true;
    if (this.isConexion) this.saveConexionConfiguration();
    else this.saveEnvironment();
  }

  saveConexionConfiguration() {
    const conectionToSend = this.tableauConfiguration;
    conectionToSend.ReportEnvironments  = [];
    this.tableauServices.saveTableauConfig(conectionToSend).subscribe(response => {
      this.responseSave(response);
    });
  }

  saveEnvironment() {
    const reportEnvironementToSend = this.reportConfiguration;
    this.tableauServices.saveReportConfig(reportEnvironementToSend).subscribe(response => {
      this.responseSave(response);
    });
  }

  responseSave(response: any) {
    this.onSave = false;
    if (response.Successful) {
      this.showToast('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY', 'success', 5000);
      this.updateTable.emit();
    }
    else this.showToast(response.Exception.Message, 'error', 0);
  }

  showToast(messageInput: string, type: BzgToastType, duration: number) {
    this._translateService.get(messageInput).subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type,
          duration: duration,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    }
    );
  }

  btnDisabled() {
    let disabled = true;
    if (this.isConexion) {
      const clientId = this.showErrorGuid(this.tableauConfiguration.Config.Environment.Params.ClientId);
      const secretId = this.passwordEncrypt(this.tableauConfiguration.Config.Environment.Params.ClientSecret);
      const secretValue = this.passwordEncrypt(this.tableauConfiguration.Config.Environment.Params.SecretValue);
      const modoValue = this.tableauConfiguration.Config.Environment.Params.UserMode;
      if (!clientId && !secretId && !secretValue) {
        disabled = false;
        if (modoValue === 'Email' && this.validateMail())
          disabled = true;
      }


    } else {
      //const workspaceId = this.showErrorGuid(this.reportConfiguration.GroupId);
      //const reportId = this.showErrorGuid(this.reportConfiguration.ReportId);
      if (this.reportConfiguration.Config.Environment.Params.Url)
        disabled = false;
    }
    if (this.onSave)
      disabled = true;
    return disabled;
  }

  showErrorGuid(guid) {
    let showError = true;
    if (guid) {
      if (guid.length === 0)
        showError = false;
      if (guid.length === 36) {
        const regex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;
        const guidValid = guid.match(regex);
        if (guidValid)
          showError = false;
      }
    }
    if (guid === '00000000-0000-0000-0000-000000000000')
      showError = true;
    return showError;
  }

  showErrorLength(guid) {
    let showError = true;
    if (guid.length === 0)
      showError = false;
    if (guid.length > 10 && guid.length <= 20)
      showError = false;
    return showError;
  }

  showErrorRequired(value) {
    return value.length === 0;
  }

  showEncryptSecretValue() {
    this.showEncryptFlagSecretValue = !this.showEncryptFlagSecretValue;
  }

  showEncryptClientSecret() {
    this.showEncryptFlagClientSecret = !this.showEncryptFlagClientSecret;
  }


  passwordEncrypt(value) {
    const regex = /^CRYPT.[1-9].BIZAGI:/g;
    return !value.match(regex);
  }

  cleanDescription() {
    this.tableauConfiguration.Description = this.tableauConfiguration.Description.replace(/\\n/g, '<br/>');
  }

  selectUserMode(userMode) {
    this.tableauConfiguration.Config.Environment.Params.UserMode = userMode;
    this.userModeSelected = userMode;
    if (userMode === 'LoggedInApps')
      this.tableauConfiguration.Config.Environment.Params.UserEmail = '';
  }

  validateMail() {
    let error = false;

    if (this.tableauConfiguration.Config.Environment.Params.UserEmail) {
      const resultado = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(this.tableauConfiguration.Config.Environment.Params.UserEmail);
      if (!resultado)
        error = true;
    } else
      error = true;
    if (error)
      this.errorMail = this._i18nService.instant('ENVIRONMENT.EMAIL_MAIL_ERROR');
    return error;
  }
}
